module.exports = __webpack_public_path__ + "img/new2.ed0178f7.png";